import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation CreatePartner($data: CreatePartnerInput!) {
    createPartner(data: $data) {
      id
    }
  }
`);

export interface CreateGql {
  createPartner: {
    id: number;
  };
}
